import { Dropdown, DropdownItem } from "nectar-ui";
import React from "react";
import { DASHBOARD_CASE_TYPES } from "../../../utils/constants/dashboard/dashboardModuleConstants";

import DashboardFilterButton from "../../DashboardFilterButton";

interface DashboardChartCaseTypeFilterProps {
  currentFilter: { label: string; queryParam: string[] };
  setFilter: (arg0: object) => void;
}

const DashboardChartCaseTypeFilter = ({
  currentFilter,
  setFilter,
}: DashboardChartCaseTypeFilterProps) => {
  const caseFilterTypes = Object.values(DASHBOARD_CASE_TYPES);

  const rangeDropdownOptions = caseFilterTypes.map((caseFilterType) => (
    <DropdownItem key={caseFilterType.label} onClick={() => setFilter(caseFilterType)}>
      {caseFilterType.label}
    </DropdownItem>
  ));

  return (
    <div style={{ position: "relative" }}>
      <Dropdown
        position="left"
        action={<DashboardFilterButton>{currentFilter.label}</DashboardFilterButton>}
        options={rangeDropdownOptions}
      />
    </div>
  );
};

export default DashboardChartCaseTypeFilter;
